import React, { forwardRef } from "react";
import PropTypes from "prop-types";

const Button = forwardRef(
	(
		{
			isLoading = false,
			disabled = false,
			className = "",
			type = "submit",
			outline = false,
			children,
			...props
		},
		ref
	) => {
		return (
			<button
				ref={ref}
				type={type}
				className={`w-full h-12 rounded-xl transition-all
        ${
					outline
						? "border border-primary-button text-primary-button bg-transparent"
						: "text-text-1 bg-primary-button"
				}
        ${
					disabled || isLoading
						? "opacity-75 cursor-not-allowed bg-gray-400 border-gray-400 text-gray-700"
						: outline
						? "hover:bg-primary-button hover:text-white"
						: "hover:bg-primary-button-hover active:bg-primary-button-active"
				}
        ${className}`}
				disabled={disabled || isLoading}
				{...props}
			>
				{isLoading ? "جاري التحميل..." : children}
			</button>
		);
	}
);

Button.displayName = "Button";
export default Button;

Button.propTypes = {
	isLoading: PropTypes.bool,
	disabled: PropTypes.bool,
	className: PropTypes.string,
	type: PropTypes.oneOf(["submit", "button", "reset"]),
	outline: PropTypes.bool,
	children: PropTypes.node.isRequired,
};
